import React from 'react';
import { Link } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface NoResultsProps {
  title: string;
  message: string;
  buttonText?: string;
  buttonLink?: string;
  icon?: React.ReactNode;
}

const NoResults: React.FC<NoResultsProps> = ({
  title,
  message,
  buttonText,
  buttonLink,
  icon,
}) => {
  return (
    <div className='flex flex-col items-center justify-center py-16 px-4 text-center'>
      <div className='mb-6 rounded-full bg-gray-100 p-6 w-24 h-24 flex items-center justify-center'>
        {icon || <MagnifyingGlassIcon className='h-12 w-12 text-gray-400' />}
      </div>

      <h2 className='text-2xl font-bold text-gray-800 mb-2'>{title}</h2>
      <p className='text-gray-600 mb-8 max-w-md'>{message}</p>

      {buttonText && buttonLink && (
        <Link
          to={buttonLink}
          className='inline-flex items-center px-6 py-3 border border-transparent font-medium rounded-full shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-300'
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
};

export default NoResults;
